import { defaultSaleDetailsState, saleDetailsViewModel$ } from '../VehicleCollectionSubjects';

import { useRxjsStore } from './useRxjsStore';

export const useSaleDetailsSub = () => useRxjsStore(saleDetailsViewModel$, defaultSaleDetailsState);
